import { useParams } from "react-router-dom";

import PageTab from "components/common/pageTab";
import TopImage from "components/common/topImage";

import ImgUrl from 'assets/images/research.png';
import {pageMenuTabList04} from 'types/common';

import 'assets/css/research.scss';

const Research = () => {
  const { researchId } = useParams<{ researchId: string }>();
  
  pageMenuTabList04[0].on = true;

  //https://img.chunhomall.com/images/brand_site/research-section-01_350x500.jpg.jpg
  const step1Rendering = () => {
    const result = [];

    for (let i = 1; i <= 6; i++) {
      const urlIndex = i < 10 ? '0' + i : i;
      result.push(
        <div className="img-style" key={i}>
          <div className="img-inner">
            <img className="none-radius" src={`https://img.chunhomall.com/images/brand_site/research-section-${urlIndex}_350x500.jpg.jpg`} alt="Research Image" />
          </div>
        </div>
      );
    }

    return result;
  }
  return (
    <div className="page_content research">
      <TopImage imgUrl="https://img.chunhomall.com/images/brand_site/research-hero_1920x1080.jpg.jpg" imgText="연구개발/품질관리" textcolor="#333"></TopImage>
      <PageTab props={pageMenuTabList04}></PageTab>
      <div className="container ">
        <div className="container-title">
          천호엔케어는<br/>
          ‘연구개발에 대한 아낌 없는 투자로 건강식품 업계를 선도한다’는<br/>
          원칙 아래 <span className="highlight">자체 연구소를 보유</span>하고 있습니다.
        </div>
        
        
        <div className="container-item">
          <div className="container-item-title">천호엔케어 R&D 센터</div>
          <div className="container-item-desc">
            천호엔케어 연구소에서는 원료의 맛과 영양을 최적의 상태로 전하는 제품개발을 위해 다양한 연구를 진행합니다.
          </div>
          <div className="reserch-middle-img">
            <img src="https://img.chunhomall.com/images/brand_site/research-section-01_1240x400.jpg.jpg" alt="Research Image" />
          </div>

          <div className="container-item-title reserch-bottom-d">천호엔케어 제조 기술 특허</div>
          <div className='container-img-grid qc'>
            {step1Rendering()}
          </div>
        </div>

      </div>
    </div>
    
  );
};

export default Research;
